import { Component } from '@angular/core';
import { GetCoupon, UpdateCoupon } from './coupon.interface';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ConvertService } from 'src/app/services/convert.service';
import { AlertService } from 'src/app/services/alert.service';
import moment from 'moment';

@Component({
  selector: 'app-coupon',
  templateUrl: './coupon.component.html',
  styleUrls: ['./coupon.component.scss']
})
export class CouponComponent {
  contentCoupon = environment.contentCoupon
  constructor(private http: HttpClient,
    private fb: FormBuilder,
    private con: ConvertService,
    private alert: AlertService
  ) {
    this.getCoupon();
  }
  formCoupon: FormGroup | any = this.fb.group(<UpdateCoupon>{
    ID: "",
    Name: "",
    Image: "",
    Image_delete: "",
    Image_update: "",
    Condition: "",
    Type: "",
    Amount: 0,
    Expire: 1,
    Expire_start_edit: "",
    Expire_end_edit: "",
    Expire_start: "",
    Expire_end: "",
    DisType: "",
    DisAmount: "",
  })
  imageAction: boolean = false;
  setitem: any = [];
  couponItems!: UpdateCoupon[]
  pageTotal: number = 0
  getCoupon(v?: any) {
    let uri: string = `coupon?page=${v?.page || 1}&limit=15`
    if (v?.value) {
      uri = `coupon?search=${v.value}&page=${v?.page || 1}&limit=15`
    }
    this.http.get(uri).subscribe({
      next: (res: any) => {
        this.couponItems = res.data
        this.pageTotal = res.pageTotal
      }
    })
  }


  message: string = ""
  manageReward: boolean = false
  addStatus: boolean = false;
  addCoupon() {
    this.message = "เพิ่มคูปอง"
    this.manageReward = true
    this.addStatus = true;
    this.setDateDefault();

  }

  updateStatus: boolean = false;
  updateItems!: UpdateCoupon
  viewCoupon(item: UpdateCoupon) {
    if (item.Image) this.imageAction = true
    this.formCoupon.patchValue(item)
    this.setDate(item)
    this.updateItems = item;
    this.message = "คูปอง"
    this.manageReward = true
    this.updateStatus = true;
  }

  viewMenu(items: any, elm: any, v: any) {
    let model: any[] = [];
    model.push({ label: 'แก้ไข', command: () => this.viewCoupon(items) });
    model.push({ label: 'ลบ', command: () => this.deleteCoupon(items) });


    this.setitem = model;
    elm.toggle(v);
  }

  setDateDefault() {
    this.formCoupon.get('Expire').setValue(1)
    let dateStart: string = ""
    let editStart: string = ""
    let dateEnd: string = ""
    let editEnd: string = ""
    // START
    editStart = moment(new Date()).format('DD/MM/YYYY')
    this.formCoupon.get('Expire_start_edit').setValue(editStart)
    dateStart = moment(new Date()).format('YYYY-MM-DD')
    this.formCoupon.get('Expire_start').setValue(dateStart)

    // END
    editEnd = moment(new Date()).format('DD/MM/YYYY')
    this.formCoupon.get('Expire_end_edit').setValue(editEnd)
    dateEnd = moment(new Date()).format('YYYY-MM-DD')
    this.formCoupon.get('Expire_end').setValue(dateEnd)
  }

  setDate(item: UpdateCoupon) {
    let dateStart: string = ""
    let editStart: string = ""
    let dateEnd: string = ""
    let editEnd: string = ""
    // START
    editStart = moment(new Date()).format('DD/MM/YYYY')
    this.formCoupon.get('Expire_start_edit').setValue(editStart)
    dateStart = moment(new Date()).format('YYYY-MM-DD')
    this.formCoupon.get('Expire_start').setValue(dateStart)

    // END
    editEnd = moment(new Date()).format('DD/MM/YYYY')
    this.formCoupon.get('Expire_end_edit').setValue(editEnd)
    dateEnd = moment(new Date()).format('YYYY-MM-DD')
    this.formCoupon.get('Expire_end').setValue(dateEnd)

    if (item.Expire_start) {
      editStart = moment(item.Expire_start).format('DD/MM/YYYY')
      this.formCoupon.get('Expire_start_edit').setValue(editStart)
      dateStart = moment(item.Expire_start).format('YYYY-MM-DD')
      this.formCoupon.get('Expire_start').setValue(dateStart)
    }
    if (item.Expire_end) {
      editEnd = moment(item.Expire_end).format('DD/MM/YYYY')
      this.formCoupon.get('Expire_end_edit').setValue(editEnd)
      dateEnd = moment(item.Expire_end).format('YYYY-MM-DD')
      this.formCoupon.get('Expire_end').setValue(dateEnd)
    }
  }



  viewImage: string = ""
  uploadFile(e: any) {
    let item: UpdateCoupon = this.formCoupon.value;
    this.formCoupon.get('Image_delete').setValue(item.Image)
    this.formCoupon.get('Image_update').setValue(e.file)
    this.viewImage = e.base64
    if (this.viewImage) this.imageAction = true
  }

  updateExpire(v: any, key: string) {
    if (key == 'start') {
      let date = moment(v).format('YYYY-MM-DD')
      this.formCoupon.get('Expire_start').setValue(date)
      return
    }
    if (key == 'end') {
      let date = moment(v).format('YYYY-MM-DD')
      this.formCoupon.get('Expire_end').setValue(date)
    }

  }


  createCoupon() {
    this.http.post(`coupon`, this.con.paseFormData(this.formCoupon.value)).subscribe({
      next: (res: any) => {
        this.getCoupon()
        this.clearEvent()
        this.alert.notify(res.message, 'success')
      }, error: (err) => {
        this.alert.dialog(err.error.message)
      },
      complete: () => {

        this.clearEvent()
      }
    })
  }

  updateCoupon() {
    this.http.put(`coupon/${this.formCoupon.value['ID']}`, this.con.paseFormData(this.formCoupon.value)).subscribe({
      next: (res: any) => {
        this.getCoupon()
        this.clearEvent()
        this.alert.notify(res.message, 'success')
      }, error: (err) => {
        this.alert.dialog(err.error.message)
      },
      complete: () => {
        this.clearEvent()
      }
    })
  }


  deleteCoupon(item: UpdateCoupon) {
    this.alert.confirm('ต้องการลบคูปองนี้หรือไม่').then(fm => {
      if (fm.isConfirmed) this.http.delete(`coupon/${item.ID}`).subscribe({
        next: (res: any) => {
          this.getCoupon()
          this.clearEvent()
          this.alert.notify(res.message, 'success')
        }, error: (err) => {
          this.alert.dialog(err.error.message)
        },
        complete: () => {
          this.clearEvent()
        }
      })
    })

  }

  deduct() {

    if (this.formCoupon.value['Deduct'] == 0) {
      this.formCoupon.get('Deduct').setValue(1)
      return
    }

    else this.formCoupon.get('Deduct').setValue(0)
  }


  expire(v: any) {
    if (v.value == 0) {
      this.formCoupon.get('Expire').setValue(1)
      this.setDate(this.formCoupon.value)
      return
    }

    else {
      this.formCoupon.get('Expire').setValue(0)
      this.formCoupon.get('Expire_start').setValue("")
      this.formCoupon.get('Expire_end').setValue("")
    }
  }


  clearEvent() {
    this.formCoupon.reset()
    this.message = ""
    this.updateStatus = false
    this.manageReward = false
    this.addStatus = false;
    this.updateStatus = false
    this.viewImage = ""
    this.imageAction = false;
  }
}


